import clienteAxios from "../config/axios";

export async function getAllNivel4s() {
    return clienteAxios.get(`/nivel4`);
}

export async function addNivel4(datos) {
    
    const codNivel4 = datos.codNivel4
    const name = datos.name
    const descrp = datos.descrp
    const nivel4Nivel3ID = datos.nivel4Nivel3._id
    const codNivel3 = datos.nivel4Nivel3.codNivel3
    const direccion = datos.direccion || null
    const lat = datos.lat || null
    const lng = datos.lng || null

    return clienteAxios.post(`/nivel4`,{codNivel4, name, descrp, nivel4Nivel3ID, codNivel3, direccion, lat, lng});
}

export async function updateNivel4(dato) {
    
    const id = dato.id
    const updates = {
        id: dato.id,
        codNivel4:dato.codNivel4,
        name: dato.name,
        descrp: dato.descrp,
        direccion: dato.direccion || null,
        lat: dato.lat || null,
        lng: dato.lng || null
    }

    return clienteAxios.put(`/nivel4/${id}`,updates);
}

export async function deleteNivel4(id) {
   
    return clienteAxios.delete(`/nivel4/${id}`,id);

}

export async function deleteNivel4AndChildren(id, deleteActivesToo) {
    return clienteAxios.delete(`/nivel4/deleteLevelAndChildren/${id}?deleteActivesToo=${deleteActivesToo}`,{id});
}


export async function updatePositioning(updates){
    return clienteAxios.post(`/nivel4/updatePositioning`,{updates});
}